export const SEO_LANGS = ['en', 'zh', 'es', 'ar', 'pt', 'fr', 'de', 'ko']

export function slugify(value) {
  if (!value) return ''
  return value
    .toString()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function buildFallbackSlug(id, value, prefix = 'item') {
  const base = slugify(value) || `${prefix}-${id}`
  return id ? `${id}-${base}` : base
}

export function replaceLangInPath(path, lang, langs = SEO_LANGS) {
  const normalized = path && path.startsWith('/') ? path : `/${path || ''}`
  const [pathname, suffix = ''] = normalized.split(/(?=[?#])/, 2)
  const segments = pathname.split('/').filter(Boolean)

  if (segments.length === 0) {
    return `/${lang}${suffix}`
  }

  if (langs.includes(segments[0])) {
    segments[0] = lang
  } else {
    segments.unshift(lang)
  }

  return `/${segments.join('/')}${suffix}`
}

export function getSiteUrl() {
  const fallbackOrigin = typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : 'https://yooxplore.com'
  return (process.env.VUE_APP_SITE_URL || fallbackOrigin).replace(/\/$/, '')
}

export function buildAlternateLinks(pathByLang, siteUrl = getSiteUrl(), defaultLang = 'en') {
  const links = []
  for (const lang of SEO_LANGS) {
    const path = pathByLang?.[lang]
    if (!path) continue
    links.push({
      vmid: `alternate-${lang}`,
      rel: 'alternate',
      hreflang: lang,
      href: `${siteUrl}${path}`,
    })
  }
  const xDefaultPath = pathByLang?.[defaultLang]
  if (xDefaultPath) {
    links.push({
      vmid: 'alternate-x-default',
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${siteUrl}${xDefaultPath}`,
    })
  }

  return links
}
